import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { URLSearchParamsConstructor } from "../../../helpers/UrlSearchParamConstructor";
import { sec } from "../../../security";
import { LitigationResponse } from "./types";

const apiServerUrl = process.env.REACT_APP_HAISTACK_API_URL;

export const apiLitigationV2Slice = createApi({
  reducerPath: "litigationV2",
  tagTypes: ["getLitigationByEmployerId", "getLitigationByAttorneyId"],
  baseQuery: fetchBaseQuery({
    baseUrl: apiServerUrl,
    prepareHeaders: async (headers) => {
      const token = await sec.getAccessTokenSilently()();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      return headers;
    }
  }),

  endpoints: (builder) => ({
    getLitigationByEmployerId: builder.query<LitigationResponse, any>({
      query: (args) => {
        const params = URLSearchParamsConstructor(args);
        return {
          url: "/api/v2/deals/employers_list",
          method: "get",
          params
        };
      },
      providesTags: ["getLitigationByEmployerId"]
    }),
    getLitigationByAttorneyId: builder.query<LitigationResponse, any>({
      query: (args) => {
        const params = URLSearchParamsConstructor(args);
        return {
          url: "/api/v2/dockets/attorney_list",
          method: "get",
          params
        };
      },
      providesTags: ["getLitigationByAttorneyId"]
    })
  })
});

export const {
  useGetLitigationByAttorneyIdQuery,
  useGetLitigationByEmployerIdQuery
} = apiLitigationV2Slice;
